<template>
  <!-- 集計表一覧 -->
  <div id="SpreadSheetMenu">
    <div id="container">
      <div class="labelTitle lable">集計表一覧（共通）</div>
      <div class="link-area">
        <div class="linkButton">
            <router-link :to="{name:'TotalInspectionsSummary', params:{}}">検査/解析件数<br>サマリー</router-link>
        </div>
        <div class="linkButton">
            <router-link :to="{name:'ShppingMonthlySummary', params:{}}">月次<br>検査レンタル器<br>出荷数サマリー</router-link>
        </div>
        <div class="linkButton">
            <router-link :to="{name:'HSTDailySummary', params:{}}">自宅配送<br>サービス集計表</router-link>
        </div>
      </div>
      <div class="labelTitle lable">集計表一覧（睡眠検査）</div>
      <div class="link-area">
        <div class="linkButton">
            <router-link :to="{name:'InspectionsSpecification', params:{}}">検査明細書</router-link>
        </div>
        <div class="linkButton">
            <router-link :to="{name:'AnalysisReport', params:{}}">解析業務報告書</router-link>
        </div>
        <div class="linkButton">
            <router-link :to="{name:'KenshinJugdmentMonthlyReport', params:{}}">判定医<br>月次レポート</router-link>
        </div>
      </div>
      <div class="labelTitle lable">集計表一覧（ホルター心電図）</div>
      <div class="link-area">
        <div class="linkButton">
            <router-link :to="{name:'HolterInspectionsSpecification', params:{}}">ホルター心電図<br>検査明細書</router-link>
        </div>
        <div class="linkButton">
            <router-link :to="{name:'HolterAnalysisReport', params:{}}">ホルター解析<br>業務報告書</router-link>
        </div>
        <div class="linkButton">
            <router-link :to="{name:'HolterAnalysisJugdmentMonthlyReport', params:{}}">ホルター心電図判定<br>月次レポート</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SpreadSheetMenu",
  methods: {},
  data() {
    return {};
  },
  components: {}
};
</script>

<style lang="scss" >
.link-area {
    width: 100%;
    min-height: 100px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.linkButton {
    margin: 10px;
    padding:5px 15px;
    height:150px;
    width: 150px;
    display: table;
    border-radius: 5px;
    background: linear-gradient(
        -35deg,
        rgb(0, 114, 218) 0%,
        rgb(110, 173, 243) 100%
    );
    background: -moz-linear-gradient(
        -35deg,
        rgb(0, 114, 218) 0%,
        rgb(110, 173, 243) 100%
    );
    background: -webkit-linear-gradient(
        -35deg,
        rgb(0, 114, 218) 0%,
        rgb(110, 173, 243) 100%
    );
    text-align: center;
    vertical-align: middle;
}
.linkButton a{
    color:whitesmoke;
    display: table-cell;
    vertical-align: middle;
}
.linkButton a:hover{
    color:whitesmoke;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/spreadSheet/menu.vue